import { Suspense } from 'react';
import { RouterProvider } from 'react-router/dom';
import { router } from './router';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppProvider } from '@contexts/app';
import { WebsocketProvider } from '@contexts/websocket';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import { isNotifiedGlobally, isSilentError, notifyQueryError } from '@services/queryErrors';

export const App = () => {
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query.meta?.silentError || isSilentError(error) || !isNotifiedGlobally(error)) return;
        notifyQueryError(error);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 2 * 1000,
        retry: false,
        refetchOnMount: 'always',
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <PostHogProvider client={posthog}>
        <AppProvider>
          <WebsocketProvider>
            <Suspense>
              <RouterProvider router={router} />
            </Suspense>
            <ReactQueryDevtools initialIsOpen={false} />
          </WebsocketProvider>
        </AppProvider>
      </PostHogProvider>
    </QueryClientProvider>
  );
};
